import axios from "axios";
import Globais, { validateToken } from "../../../components/Globais";

// Função para buscar o proprietario

export const proprietariosService = async (usuarioId: number) => {
  const Token = validateToken();
  if (Token) {
    const URL = `${Globais.DOMINIOBACK}/usuario/${usuarioId}`;

    try {
      const response = await axios.get(URL, {
        headers: { Authorization: Token.AuthStr },
      });

      const proprietario = {
        key: response.data.id,
        nome: response.data.nome,
        sobrenome: response.data.sobrenome,
        email: response.data.email,
        cpf: response.data.cpf,
        celular: response.data.celular,
        nacionalidade: response.data.nacionalidade,
        estadoCivil: response.data.estadoCivil,
      };

      return proprietario; // Agora retorna o array processado
    } catch (error) {
      console.log(error);
    }
  }
  return false; // Retorna um array vazio se o Token não for válido
};

export {};
